import React from 'react';
import DialogContentText from "@material-ui/core/DialogContentText";
import Variaciones from './Variaciones';
import './tabla.css';

export default function TablaProductos(props) {
    const { idProducto, addProductCart }  = props;
    return (
        <DialogContentText id="alert-dialog-description">
        <table className="table table-striped" id="carrito">
          <tr>
            <th scope="col-1">Imagen</th>
            <th scope="col-1">Opción</th>
            <th scope="col-1" className="tablaPrecio" >Precio</th>
            <th scope="col-1">Añadir</th>
          </tr>
          <Variaciones idProducto={idProducto} addProductCart={addProductCart}/>                    
        </table>
  
 </DialogContentText> 
    )
}
